<!--
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-17 11:18:28
 * @LastEditTime: 2020-10-13 17:14:07
 * @Description: File description
-->
<template>
  <div class="register">
    <img src="../assets/images/bg-register.png" alt="活动背景">
    <img class="register-reward" src="../assets/images/reward-register.png" alt="活动奖励">
    <div class="register-video">
      <video ref="video" src="https://zt.xueersi.com/video/realizeWx.mp4"
        controls preload="auto"
        x5-video-player-type="h5"
        x-webkit-airplay="true"
      ></video>
    </div>
    <img class="register-corp" src="../assets/images/register-corp.png" alt="公司商标">
    <!-- 新版按钮悬浮 -->
    <div class="register-container" v-if="inputShow">
      <div class="register-form">
        <input
          v-if="showinput"
          class="register-input register-input"
          type="tel"
          name="phone"
          placeholder="请输入手机号"
          maxlength="11"
          @blur="phoneblur"
          v-model="phone"
        />
        <transition name="fade">
          <div v-if="isShowGradeList">
            <p class="register-code-tips">验证码已发送至手机号{{ phoneChange }}</p>
            <div class="register-code-container">
              <input
                class="register-code-input"
                type="tel"
                @blur="codeblur"
                name="code"
                placeholder="请输入验证码"
                maxlength="6"
                v-model="code"
              />
              <div
                class="register-get-code-btn"
                v-if="!sendMsgDisabled"
                @click="getVerification"
              >获取验证码</div>
              <div class="register-get-code-btn disabled" v-if="sendMsgDisabled">{{ time + "秒" }}</div>
            </div>
            <div
              class="register-input register-grade-select"
              :class="{ active: gradePopup }"
              @click="gradePopup = true"
            >{{ currentPicker.gradeName || "请选择当前在读年级" }}</div>
          </div>
        </transition>
      </div>
    </div>
    <div class="regsubmit">
      <div class="threeD_btn" @click="phoneShow"></div>
    </div>
    <!--检测微信登录态弹层-->
    <!-- <CheckLogin @sureClick="toMall" @changeAcount="changeAcount" /> -->
    <!-- 安全验证弹窗 -->
    <!-- <slider-confirm ref="sliderConfirm" /> -->
    <!-- 年级的picker选择列表 -->
    <van-popup v-model="gradePopup" position="bottom" :closeOnClickModal="false">
      <van-picker
        :columns="newslots"
        value-key="gradeName"
        :show-toolbar="true"
        @change="onChange"
        @cancel="gradePopup = false"
        @confirm="confirmGrade"
      ></van-picker>
    </van-popup>
    <!-- 老用户去商城的弹窗 -->
    <!-- <van-popup v-model="isOldShow"> -->
      <!-- 背景图片 -->
      <!-- <div class="register-popup"> -->
        <!-- 关闭按钮 -->
        <!-- <div class="register-popup-close" @click="closePop"></div> -->
        <!-- 去往商城 -->
        <!-- <div class="register-popup-btn" @click="goTouchShop"></div> -->
      <!-- </div> -->
    <!-- </van-popup> -->
  </div>
</template>

<script>
import CheckLogin from '@/inviteNew/components/CheckLogin'
import LoginSdk from '@/inviteNew/components/talLogin/LoginSdk.js'
import SliderConfirm from '@/inviteNew/components/talLogin/sliderConfirm/index'

export default {
  components: {
    CheckLogin,
    SliderConfirm
  },
  data () {
    return {
      time: 59, // 发送验证码倒计时
      code: '', // 验证码
      phone: '', // 手机号
      query: {}, // url上的参数
      timer: null, // 定时器
      inviteId: '',
      newslots: [], // 年级列表
      teacherId: '',
      isShow: false, // 底部浮层的显示和隐藏 // NEXT: 这玩意没用到啊
      school_year: '',
      isSubmit: false,
      isNewUser: false,
      youngUser: 20036,
      showinput: false, // 手机号输入框
      inputShow: false, // 用户手机信息输入 弹层
      isOldShow: false, // 老用户弹框是否显示
      currentPicker: {}, // 当前选择的年级对象
      gradePopup: false,
      scrollHeight: 150, // 默认首屏加100显示吸顶按钮 // NEXT: 这玩意没用到啊
      isShowVideoPlay: true, // 视频播放按钮
      sendMsgDisabled: false,
      isShowGradeList: false // 是否显示注册年级
    }
  },
  created () {
    const _phone = sessionStorage.getItem('userPhone')
    if (_phone) {
      this.phone = _phone
      this.isShowGradeList = true
      sessionStorage.setItem('userPhone', '')
    }
    this.$api.getGradeList().then(res => {
      if (res.stat === 1) {
        this.newslots = res.data
      }
    })
    // 判断是否为幼小老带新
    this.youngUser = this.$route.query.s === '20036'
    this.inviteId = this.$route.query.userId
    this.teacherId = this.$route.query.teacherId
    this.$xesLogger.clickMsg({ params: { action: 'newUserTutorid', clickid: '3.3.2', tutorId: this.$route.query.teacherId } })
  },
  computed: {
    phoneChange () {
      return this.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
    }
  },
  methods: {
    // 输入手机号失去焦点了
    phoneblur () {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'phoneblur', clickid: '5.2.7', info: `${this.phone}` }
      })
    },
    // 输入验证码失去焦点
    codeblur () {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'code', clickid: '5.2.8' }
      })
    },
    // 年级修改
    onChange (picker, value) {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: {
          action: 'inchoice',
          clickid: '5.2.9',
          selectinfo: value.gradeName
        }
      })
    },
    confirmGrade (value) {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: {
          clickid: '5.2.10',
          action: 'selectgrade',
          selectinfo: value.gradeName
        }
      })
      this.gradePopup = false
      this.currentPicker = value
    },
    countDown () {
      // 60秒倒计时模块
      this.timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          this.time = 59
          this.sendMsgDisabled = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    getVerification () {
      // 点击获取验证码
      this.sendMsgDisabled = true
      this.sendLoginCode()
    },
    // 1. sdk发送登录或者注册验证码
    sendLoginCode () {
      const data = {
        test: 666,
        sgroupId: 999,
        verify_type: 1,
        phone_code: '86',
        phone: this.phone
      }
      const sendSMSCodeParams = {
        data,
        success: res => {
          console.log('sendcode', res)
          if (res.errcode === 0) {
            // 发送验证码成功
            this.countDown() // 获取倒计时
            this.$toast('短信已发送，请注意查收')
            this.isShowGradeList = true
            this.$refs.sliderConfirm.changeSliderConfirm(false) // 关闭滑动验证弹窗
            // 是否是新用户
            this.isNewUser = res.data.is_exist === 1
          } else if (res.errcode === 11021) {
            // 需要滑动验证
            this.$refs.sliderConfirm.changeSliderConfirm(true) // 打开 滑动验证弹窗
            this.$refs.sliderConfirm.sliderConfirm('sendSMSCodeLogin', sendSMSCodeParams) // 调取集团进行滑动验证的接口
          } else {
            this.$toast(res.errmsg)
            this.$refs.sliderConfirm.changeSliderConfirm(false) // 关闭 滑动验证弹窗
          }
        },
        fail: error => {
          this.$toast('网络异常，请检查网络')
          console.log(error, '网络异常，请检查网络')
        }
      }
      window.TAL_UC.sendSMSCodeLogin(sendSMSCodeParams)
    },
    // 领取优惠券礼包
    register (e) {
      const phonereg = /^[1][3-9][0-9]{9}$/
      const verificationReg = /[0-9]{6}$/

      if (!this.isShowGradeList) {
        // 领取新生优惠券礼包按钮
        if (this.phone === '') {
          this.$toast({ message: '请输入手机号', duration: 1500 })
          return
        }
        if (!phonereg.test(this.phone)) {
          this.$toast({ message: '请输入正确手机号', duration: 1500 })
          this.phone = ''
          return
        }
        this.$xesLogger.clickMsg({
          elem: e.target,
          params: { action: 'sendRegVCode', clickid: '5.2.4' }
        })
        this.sendLoginCode()
        return
      }

      if (this.code === '') {
        this.$toast({ message: '请输入手机验证码', duration: 1500 })
        return
      }

      if (!verificationReg.test(this.code)) {
        this.$toast({ message: '请输入正确验证码', duration: 1500 })
        return
      }

      if (!this.currentPicker.gradeId) {
        this.$toast({ message: '请选择当前在读年级', duration: 1500 })
        return
      }
      this.school_year = (this.currentPicker.gradeId > 13) ? ((new Date()).getFullYear() - this.currentPicker.gradeId + 27) : ((new Date()).getFullYear() - this.currentPicker.gradeId + 2)
      console.log('入学年份：', this.school_year)
      this.loginSdk()
    },
    loginSdk () {
      this.$toast.loading({ mask: false, message: '领取中...' })
      const data = {
        phone_code: 86, // 手机地区码
        phone: this.phone, // 地区不同手机号码规则不同
        sms_code: this.code, // 短信验证码
        school_year: this.school_year,
        currentPicker: this.currentPicker,
        sGroupId: this.$route.query.s || 20001, // 活动
        inviteOldUserId: this.$route.query.u || '', // 老用户
        inviteOrigin: this.$route.query.origin || 0,
        source_id: this.$route.query.source_id || '' // 获取渠道
      }
      if (!this.isNewUser) {
        // 注册参数
        Object.assign(data, this.regData)
      } else {
        // 登录参数
        Object.assign(data, this.loginData)
      }
      const loginSmsParmas = {
        data,
        success: res => {
          this.$toast.clear()
          if (res.errcode === 0) {
            this.$refs.sliderConfirm.changeSliderConfirm(false)
            const getTokenParams = {
              ...data,
              code: res.data.code
            }
            LoginSdk.getToken(getTokenParams).then(result => {
              if (result.stat === 1) {
                // 网校token保留成功
                switch (result.data.code_type) {
                  case 1:
                    // 老用户登录
                    this.isOldShow = true
                    this.$xesLogger.clickMsg({ params: { action: 'loginSdk', clickid: '5.3.15' } })
                    localStorage.setItem('userId', result.data.user_info.user_id)
                    this.$emit('login', {
                      phone: this.phone,
                      data: result.data
                    })
                    break
                  case 2:
                    // 新用户注册成功 修改用户年级信息
                    this.$api.bindUserRelation({
                      inviteId: this.inviteId,
                      teacherId: this.teacherId
                    })
                    window.TAL_UC.modifyUserInfo({
                      data: {
                        school_year: this.school_year
                      },
                      success: function (e) {
                        console.log('新用户', e)
                      },
                      fail: function (e) {
                        console.log(e)
                      }
                    })
                    this.$xesLogger.clickMsg({
                      elem: document.body,
                      params: { action: 'inviteReg', clickid: '5.2.6', status: `${result.stat}` }
                    })
                    this.$router.push({ name: 'discount', query: this.$route.query })
                    this.$emit('reg', {
                      phone: this.phone,
                      data: result.data
                    })
                    break
                }
              } else {
                this.$toast(result.data)
              }
            })
          } else if (res.errcode === 11021) {
            this.$refs.sliderConfirm.changeSliderConfirm(true)
            this.$refs.sliderConfirm.sliderConfirm('loginSms', loginSmsParmas)
          } else {
            this.$refs.sliderConfirm.changeSliderConfirm(false)
            this.$toast(res.errmsg)
          }
        },
        fail: error => {
          this.$toast.clear()
          const tips = error.errmsg || '网络异常，请检查网络'
          this.$toast(tips)
        }
      }
      window.TAL_UC.loginSms(loginSmsParmas)
    },
    goTouchShop () {
      this.$xesLogger.clickMsg({
        params: { action: 'goTouchShop', clickid: '5.2.5' }
      })
      this.$router.push({ path: '/sharePage' })
    },
    changeAcount () {
      this.phoneShow()
    },
    toMall () {
      this.isOldShow = true
      this.$xesLogger.clickMsg({ params: { action: 'toMall', clickid: '5.3.14' } })
    },
    // 点击按钮，弹出手机输入框
    phoneShow (e) {
      if (this.phone) {
        this.register(e)
        this.showinput = false
      } else {
        this.showinput = true
        this.inputShow = true
      }
    },
    closePop () {
      this.isOldShow = false
      this.phone = ''
    }
  }
}
</script>

<style lang="less" scoped>
.register {
  width: 100vw;
  padding-bottom: 85px;
  background-size: 100%;

  .register-reward {
    position: absolute;
    top: 310px;
    left: 50%;
    transform: translateX(-50%);
  }

  .register-video {
    width: 351px;
    height: 197px;
    margin: 0 auto;
    margin-top: 14px;
    background: #000;
    box-shadow: 0 2px 7px 0 rgba(247, 208, 138, 0.83);

    & > video {
      width: 100%;
      height: 100%;
      background: #000;
    }
  }

  .register-corp {
    margin: 20px auto;
  }

  .register-container {
    position: fixed;
    bottom: 85px;
    z-index: 99;
    width: 100%;
    padding-top: 15px;
    margin: 0;
    background-color: #fff;
    box-shadow: none;

    .register-form {
      position: relative;
      width: 100%;
      padding: 0;
      margin: 0 auto;
      color: rgb(80, 79, 79);

      .register-input {
        width: 325px;
        height: 40px;
        padding: 0;
        margin: 0;
        line-height: 23px;
        line-height: 41px;
        text-align: center;
        color: rgba(252, 140, 31, 1);
        border: 1px solid rgba(255, 192, 44, 1);
        border-radius: 20px;
        opacity: 1;
      }

      .register-grade-select {
        height: 41px;
        margin: 0 auto;
        color: rgba(252, 140, 31, 1);
      }

      .register-code-tips {
        width: 214px;
        margin: 10px auto;
        font-size: 13px;
        font-weight: 400;
        font-family: PingFang SC;
        line-height: 13px;
        color: rgba(252, 140, 31, 1);
      }

      .register-code-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 325px;
        margin: 0 auto 10px;
        line-height: 26px;
        border: 1px solid rgba(255, 192, 44, 1);
        border-radius: 22px;

        .register-code-input {
          width: 295px;
          height: 40px;
          padding: 5px 20px;
          font-size: 14px;
          line-height: 40px;
          color: rgba(255, 192, 44, 1);
          background: rgba(255, 255, 255, 1);
          border-radius: 22px;
        }

        .register-get-code-btn {
          flex: 1 1 auto;
          width: 130px;
          height: 24px;
          font-size: 12px;
          font-size: 3.2vw;
          font-weight: bold;
          line-height: 24px;
          color: rgba(252, 140, 31, 1);
          border-left: 1px solid rgba(251, 240, 183, 1);
        }
      }

      input::-webkit-input-placeholder {
        font-size: 14px;
        font-weight: 400;
        font-family: PingFang SC;
        color: rgba(252, 140, 31, 1);
        opacity: 0.6;
      }
    }
  }
  // 底部悬浮按钮
  .regsubmit {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 85px;
    background: #fff;

    .threeD_btn {
      width: 332px;
      height: 85px;
      margin: 0 auto;
      background: url("../assets/images/register-invite.png") no-repeat center;
      background-size: contain;
    }
  }
  // 弹窗
  .register-popup {
    width: 236px;
    height: 261px;
    background: url("../assets/images/invite-none.png") no-repeat;
    background-size: contain;

    .register-popup-close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 15px;
      height: 15px;
      background: url("../assets/images/close-orange.png") no-repeat;
      background-size: cover;
    }

    .register-popup-btn {
      position: absolute;
      bottom: 15px;
      left: 50%;
      width: 202px;
      height: 32px;
      background: url("../assets/images/register-invite.png") no-repeat center;
      background-size: contain;
      transform: translateX(-50%);
    }
  }
}
</style>
